/* template */
<template><div class="popover-dawn-wapper"><es-icon name="exclamation-circle-filled" size="14" class="popover-icon"/>{{ text }}</div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m6d0fa431"}'>
  .popover-dawn-wapper
    height 64rpx
    color #FF6F2A
    font-size 24rpx
    padding-left 24rpx
    font-weight 400
    display flex
    align-items center
    background rgba(255, 244, 238, 0.5)
    border 2rpx solid rgba(255, 111, 42, 0.16)
    border-radius 16rpx
    margin 0 32rpx
  .popover-icon
    padding-right 4px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m6d0fa431"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./popover.mpx.js?isComponent&outputPath=components%2Fpopover6d0fa431%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./popover.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fpopover6d0fa431%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m6d0fa431"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/popover6d0fa431/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
